@if (open()) {
  <div
    class="ui-image-lightbox"
    [class.ui-image-lightbox--caption]="!!caption()"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="(normalizedIndex() + 1) + ' de ' + images().length"
    (pointerdown)="onSwipeStart($event)"
    (pointerup)="onSwipeEnd($event)"
  >
    <header class="ui-image-lightbox__header">
      <p class="ui-image-lightbox__count">
        {{ normalizedIndex() + 1 }} de {{ images().length }}
      </p>
      <button
        type="button"
        class="ui-image-lightbox__close"
        aria-label="Cerrar"
        (click)="close()"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path
            d="M6 6l12 12M18 6 6 18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </header>
    <div
      class="ui-image-lightbox__stage"
      (touchstart)="onPinchStart($event)"
      (touchmove)="onPinchMove($event)"
      (touchend)="onPinchEnd($event)"
      (touchcancel)="onPinchEnd($event)"
    >
      <div
        class="ui-image-lightbox__reel"
        [class.ui-image-lightbox__reel--pair]="incomingIndex() !== null"
        [class.ui-image-lightbox__reel--next]="
          incomingIndex() !== null && direction() === 'next'
        "
        [class.ui-image-lightbox__reel--prev]="
          incomingIndex() !== null && direction() === 'prev'
        "
        [class.ui-image-lightbox__reel--run]="pushing()"
        (transitionend)="onPushEnd($event)"
      >
        @for (frame of frames(); track frame.index) {
          <div class="ui-image-lightbox__frame">
            <img
              class="ui-image-lightbox__image"
              [src]="frame.src"
              [alt]="alt()"
              [style.transform]="
                'scale(' + (frame.index === normalizedIndex() ? zoom() : 1) + ')'
              "
            />
          </div>
        }
      </div>
    </div>
    @if (caption()) {
      <footer class="ui-image-lightbox__footer">{{ caption() }}</footer>
    }
  </div>
}
